// components/branches/config/appointment/CapacityManagementSettings.jsx
import React from "react";
import NumberInput from "../../../common/NumberInput";

const CapacityManagementSettings = ({ config, onChange, isEditMode }) => {
  const handleChange = (field, value) => {
    onChange({ ...config, [field]: value });
  };

  const handleVipQuotaChange = (field, value) => {
    onChange({
      ...config,
      vipQuota: { ...config.vipQuota, [field]: value },
    });
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">Capacity Management</h3>

      {/* Daily Capacity */}
      <div className="bg-gray-50 rounded-lg p-6 space-y-4">
        <h4 className="font-medium">Daily Limits</h4>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Max Appointments Per Day
            </label>
            {isEditMode ? (
              <NumberInput
                value={config.maxAppointmentsPerDay || 20}
                onChange={(value) =>
                  handleChange("maxAppointmentsPerDay", value)
                }
                min="1"
                max="100"
                className="w-32 focus:ring-2 focus:ring-blue-500"
              />
            ) : (
              <p className="text-2xl font-bold text-blue-600">
                {config.maxAppointmentsPerDay || 20}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Max Appointments Per Hour
            </label>
            {isEditMode ? (
              <NumberInput
                value={config.maxAppointmentsPerHour || 4}
                onChange={(value) =>
                  handleChange("maxAppointmentsPerHour", value)
                }
                min="1"
                max="20"
                className="w-32 focus:ring-2 focus:ring-blue-500"
              />
            ) : (
              <p className="text-2xl font-bold text-green-600">
                {config.maxAppointmentsPerHour || 4}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* VIP Quota */}
      <div className="bg-purple-50 rounded-lg p-6 space-y-4">
        <div className="flex items-start justify-between">
          <div>
            <h4 className="font-medium">VIP Customer Quota</h4>
            <p className="text-sm text-gray-600 mt-1">
              Reserve slots for premium customers
            </p>
          </div>
          {isEditMode ? (
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={config.vipQuota?.enabled || false}
                onChange={(e) =>
                  handleVipQuotaChange("enabled", e.target.checked)
                }
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
            </label>
          ) : (
            <span
              className={`px-3 py-1 rounded-full text-sm font-medium ${
                config.vipQuota?.enabled
                  ? "bg-green-100 text-green-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {config.vipQuota?.enabled ? "Enabled" : "Disabled"}
            </span>
          )}
        </div>

        {config.vipQuota?.enabled && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              VIP Slots Per Day
            </label>
            {isEditMode ? (
              <NumberInput
                value={config.vipQuota?.slotsPerDay || 2}
                onChange={(value) => handleVipQuotaChange("slotsPerDay", value)}
                min="1"
                max="10"
                className="w-24 focus:ring-2 focus:ring-blue-500"
              />
            ) : (
              <p className="text-lg font-semibold">
                {config.vipQuota?.slotsPerDay || 2} slots
              </p>
            )}
          </div>
        )}
      </div>

      {/* Capacity Visualization */}
      <div className="bg-white border-2 border-gray-200 rounded-lg p-6">
        <h4 className="font-medium mb-4">Capacity Overview</h4>
        <div className="space-y-3">
          <div>
            <div className="flex justify-between text-sm mb-1">
              <span>Daily Capacity</span>
              <span>{config.maxAppointmentsPerDay || 20} appointments</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-4">
              <div
                className="bg-blue-600 h-4 rounded-full"
                style={{ width: "75%" }}
              ></div>
            </div>
          </div>

          {config.vipQuota?.enabled && (
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span>VIP Reserved</span>
                <span>{config.vipQuota?.slotsPerDay || 2} slots</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-4">
                <div
                  className="bg-purple-600 h-4 rounded-full"
                  style={{ width: "20%" }}
                ></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CapacityManagementSettings;
